import { createFileRoute } from "@tanstack/react-router";
import { SilverPage, silverRatesQO } from "@/components/SilverPage";
import { buildAliasHead } from "@/lib/alias-routes";

const TITLE = "Today's Live Chandi Ka Rate in Lahore — 1 Tola & 10 Gram Silver Price";
const DESC = "Live silver / chandi rate in Lahore today — per tola, per 10 gram, per gram & per kg. Hourly auto-update from international XAG spot + USD/PKR FX.";

export const Route = createFileRoute("/silver-rate-lahore")({
  head: () => buildAliasHead({ title: TITLE, description: DESC, path: "/silver-rate-lahore" }),
  loader: ({ context }) => context.queryClient.ensureQueryData(silverRatesQO),
  component: () => (
    <SilverPage
      country="pakistan"
      cityName="Lahore"
      title="Today's Live Chandi (Silver) Rate in Lahore"
      intro="Live silver rate in Lahore — recalculated every 10 minutes from international XAG spot price and today's USD/PKR rate. Per tola, per 10 gram, per gram and per kilogram."
    />
  ),
});
